import { gql } from '@apollo/client';

export const getAllActiveTemplates = gql`
  query {
    optionTemplates(filter: {isActive: true}) {
      id
      isActive
      seller {
        id
        name
        sellerPageMessage
        startButtonText1
        startButtonText2
        externalId {
          externalId
        }
        districtGroups {
          id
          displayName
          isActive
          boundaries {
            id
            eeDistrictId
            eeDistrictName
          }
        }
      }
      buyerOptions(showBuyerCreationOnly: true) {
        id
        key
        label
        description
        value
        inputType
        detailType
        uiElement
        isRequired
        uiOrder
      }
      goodOptions {
        id
        category
        good {
          id
          name
          logo
          description
          isReferral
        }
        passThroughTemplate {
          id
          seller {
            id
            name
          }
        }
      }
    }
  }
`;

export const getStateTemplate = gql`
  query getStateTemplate($filter: OptionTemplateFilter) {
    optionTemplates(filter: $filter) {
      id
      isActive
      seller {
        id
        name
        website
        sellerPageMessage
        startButtonText1
        startButtonText2
        districtGroups {
          id
          displayName
          isActive
          boundaries {
            id
            eeDistrictId
            eeDistrictName
          }
        }
      }
      buyerOptions(showBuyerCreationOnly: true) {
        id
        key
        label
        description
        value
        inputType
        detailType
        uiElement
        isRequired
        uiOrder
      }
      goodOptions {
        id
        category
        good {
          id
          name
          logo
          description
          isReferral
        }
        passThroughTemplate {
          id
          seller {
            id
            name
          }
        }
      }
    }
  }
`;